<div class="detail-page">
  <div class="detail-page__header" [class.pinned]="isPinChecked" >
    <a *ngIf="cameFromSearch()" href="#" (click)="onClickBack($event)" mat-button type="button" class="detail-page__back-btn">
      <mat-icon>chevron_left</mat-icon>
      <span class="detail-page__back-text">Back to Results</span>
    </a>
    <a href="#" (click)="onClickNewSearch($event)" mat-button type="button" class="detail-page__new-search-btn">
      <mat-icon>search</mat-icon>
      <span class="detail-page__back-text">New Search</span>
    </a>
    <div class="detail-page__pin-search-bar">
      <mat-checkbox class="pin-search-bar" [(ngModel)]="this.isPinChecked" (change)="onChange($event)">Pin search bar</mat-checkbox>
    </div>
    <div class="detail-page__header-main">
      <!-- <span class="detail-page__prefix-label">View Airport Information by:</span> -->
    </div>
    <!-- <nav mat-tab-nav-bar class="detail-page__tabs">
      <a mat-tab-link class="detail-page__tab-link"
         *ngFor="let link of navLinks"
         [routerLink]="link.params"
         routerLinkActive="detail-page__tab-link--active"
         #rla="routerLinkActive"
         [active]="rla.isActive">
        <mat-icon class="detail-page__tab-icon">{{link.icon}}</mat-icon>
        <span class="detail-page__tab-text">{{link.label}}</span>
      </a>
    </nav> -->
    <div class="detail-page__search-container">
      <app-autocomplete class="detail-page__search"></app-autocomplete>
    </div>
  </div>
  <div class="detail-page__content-wrapper">
    <router-outlet (activate)="onRouterOutletActivate($event)"></router-outlet>
  </div>
  <app-app-footer></app-app-footer>
</div>
